import { ODSGlobalHeaderLanguageSelect } from '@telekom-ods/react-ui-kit';
import { useDispatch } from 'react-redux';

import { useUserData } from '../../redux/selectors';
import { setLocale } from '../../redux/user/actions';

const LanguageSwitcher = () => {
  const dispatch = useDispatch();
  const { locale = 'en' } = useUserData();

  const handleSelect = (nextLocale: string): void => {
    if (nextLocale === locale) return;

    try {
      globalThis.localStorage.setItem('locale', nextLocale);
    } catch (error) {
      console.error('Failed to set locale in localStorage:', error);
    }
    dispatch(setLocale(nextLocale));
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <ODSGlobalHeaderLanguageSelect
        aria-label='EN'
        asChild={false}
        label='EN'
        selected={locale === 'en'}
        onClick={() => {
          handleSelect('en');
        }}
      />{' '}
      |
      <ODSGlobalHeaderLanguageSelect
        aria-label='DE'
        asChild={false}
        label='DE'
        selected={locale === 'de'}
        onClick={() => {
          handleSelect('de');
        }}
      />
    </div>
  );
};

export default LanguageSwitcher;
